module.exports = __webpack_public_path__ + "static/media/Stacie East_1623825683993.0f6975a3.jpeg";